import { COUNTRY_OPTIONS } from '@shared/constants/countries';
import { LinxFormAddressModel } from '@shared/models';

const countryName = (code?: string): string | undefined => COUNTRY_OPTIONS.find(({ value }) => value === code)?.label ?? code;

const joined = (parts: (string | undefined)[], separator: string): string => parts.filter(Boolean).join(separator);

/**
 * The lines of a saved-address card (KOR-15208, Figma 8280:8012): street, "City, ST ZIP", country name. A shipping
 * card leads with the contact name, as a shipping label does. Missing parts are left out rather than shown blank.
 */
export const addressSummaryLines = (address: LinxFormAddressModel, { withContactName = false } = {}): string[] =>
  [
    withContactName ? joined([address.contactFirstName, address.contactMiddleName, address.contactLastName], ' ') : '',
    joined([address.addressLine1, address.addressLine2], ', '),
    joined([address.city, joined([address.state, address.postalCode], ' ')], ', '),
    countryName(address.country),
  ].filter((line): line is string => !!line);
